import { useState } from 'react';
import { Popover } from '@consta/uikit/Popover';

export const ContentHoverPopover = ({ children, content }: React.PropsWithChildren<Props>) => {
  const [position, setPosition] = useState<{ x: number; y: number }>();

  return (
    <>
      <div
        onMouseMove={(e: React.MouseEvent) => setPosition({ x: e.clientX, y: e.clientY + 16 })}
        onMouseLeave={() => setPosition(undefined)}
      >
        {children}
      </div>
      <Popover
        direction="downCenter"
        spareDirection="downStartLeft"
        position={position}
        isInteractive={false}
        style={{ zIndex: 100 }}
      >
        {content}
      </Popover>
    </>
  );
};

type Props = {
  content: React.ReactNode | string;
};
